import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import HeaderNano from '../../components/shared/SeoHeader';
// import Header from './Header';
import MainFeaturedPost from './MainFeaturedPost';
import Main from './Main';
import Sidebar from './Sidebar';
// import Footer from '../Layouts/footer';
import FooterLight from '../../components/shared/SeoFooter';
import post1 from './privc.md';
import post2 from './blog-post.2.md';
import post3 from './blog-post.3.md';
import {
  faLinkedin,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { logger } from '../../utils/logger';

const sxStyles = {
  mainGrid: {
    marginTop: '160px',
  },
};

const sections = [
  {title: 'Technology', url: '#'},
  {title: 'Design', url: '#'},
  {title: 'Culture', url: '#'},
  {title: 'Business', url: '#'},
  {title: 'Politics', url: '#'},
  {title: 'Opinion', url: '#'},
  {title: 'Science', url: '#'},
  {title: 'Health', url: '#'},
  {title: 'Style', url: '#'},
  {title: 'Travel', url: '#'},
];

const mainFeaturedPost = {
  title: 'Title of a longer featured blog post ',
  description:
    "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
  image: '/HevolveBanner.webp',
  imgText: 'main image description',
  linkText: 'Continue reading…',
};


const posts = [post1, post2, post3];
// const posts = [post1, post2, post3];

const sidebar = {
  title: 'About',
  description:
    "A team of passionate people who believe in improving everyone's life using AI. We build products to solve real world problems.",
  archives: [
    ],
  social: [
    {
      name: 'Youtube',
      icon: faYoutube,
      link: 'https://www.youtube.com/channel/UClzFvo8SECdyd0dVQhJ2Cbg',
    },
    {
      name: 'Linkedin',
      icon: faLinkedin,
      link: 'https://www.linkedin.com/company/hertz-ai/',
    },
    {
      name: 'Twitter',
      icon: faTwitter,
      link: 'https://twitter.com/AiHertz?s=20',
    },
  ],
};

export default function PrivacyBlog() {
  const [posts, setPosts] = React.useState([]);

  React.useEffect(() => {
    logger.log('Blog is fully loaded');
    //getAllAssessmentNames();
    fetch(post1)
      .then((res) => res.text())
      .then((postContent) => setPosts([postContent]))
      .catch((err) => console.error(err));
  }, []);

  return (
    <React.Fragment>
      <HeaderNano />
      <Container maxWidth="lg">
        {/* <Header title="Blog" sections={sections} /> */}
        <main>
          {/* <MainFeaturedPost post={mainFeaturedPost} /> */}
          {/* <Grid container spacing={4}>
            
          </Grid> */}
          <Grid container spacing={5} sx={sxStyles.mainGrid}>
            <Main
              title="PRIVACY POLICY - HEVOLVE"
              posts={posts}
              discoverMore="none"
            />
            <Sidebar
              title={sidebar.title}
              description={sidebar.description}
              archives={sidebar.archives}
              social={sidebar.social}
            />
          </Grid>
        </main>
      </Container>
      <FooterLight />
    </React.Fragment>
  );
}
